import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Histo-Pheno")

import { Node } from "@/api/node-lookup";
import HistoPheno from "./HistoPheno.vue";

interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionVisualization',
  props: {
    node: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (__props.node.category === 'disease')
    ? (_openBlock(), _createBlock(_component_AppSection, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_AppHeading, { icon: "chart-bar" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(HistoPheno, { node: __props.node }, null, 8, ["node"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})